export enum BUTTON_STATES_LABEL {
  confirmBet = 'CONFIRM_BET_CAPS',
  cancelBet = 'CANCEL_BET_CAPS',
  cashout = 'CASH_OUT_CAPS',
  cashed = 'CASHED_CAPS',
  flewAway = 'CRASH_FLEW_AWAY',
  lowBalance = 'LOWGAMEBALANCE_CAPS',
}

export enum BUTTON_STATES {
  confirm = 'confirm',
  cancel = 'cancel',
  cashout = 'cashout',
  cashed = 'cashed',
  flewAway = 'flewaway',
  lowbalance = 'lowbalance',
}

export type ButtonStateType = {
  label: BUTTON_STATES_LABEL;
  state: BUTTON_STATES;
};
